module.exports = __webpack_public_path__ + "img/chevron-left.9c5cf771.svg";